<div class="mat-elevation-z8">
  <table mat-table class="stripped-table" #creditOutletsTable [dataSource]="dataSource" matSort>

    <!-- Field Column -->
    <ng-container matColumnDef="field">
      <th mat-header-cell *matHeaderCellDef> Field </th>
      <td mat-cell class="name-column" *matCellDef="let row"> {{row.field}} </td>
    </ng-container>

    <!-- Value Column -->
    <ng-container matColumnDef="value">
      <th mat-header-cell *matHeaderCellDef> Value </th>
      <td mat-cell *matCellDef="let row">
        {{row.value}}
        @if (row.field=='Gross Equity' && !isCalculated) {
          <span><mat-icon>emergency</mat-icon></span>
        }
        @if (row.field=='Gross Equity' && isCalculated) {
          <span><mat-icon>emergency</mat-icon><mat-icon>emergency</mat-icon></span>
        }
      </td>
    </ng-container>

    <!--    <tr mat-header-row *matHeaderRowDef="dataColumns"></tr>-->
    <tr mat-row *matRowDef="let row; columns: dataColumns;"></tr>
  </table>
  <div>
    <small>
      <small>&nbsp;<mat-icon>emergency</mat-icon>&mdash; Denotes manually estimated gross equity values.</small>
    </small>
  </div>
  <div>
    <small>
      <small>&nbsp;<mat-icon>emergency</mat-icon><mat-icon>emergency</mat-icon>&mdash; Denotes calculated gross equity values using an 8% load (4% for certificated).</small>
    </small>
  </div>
</div>
